"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "First, can you write down any unhelpful or negative thoughts that you’re having about the coronavirus",
  type: "multiWithOther",
  meta: {
    answerLabel: "Please write your personal unhelpful thought here",
    summaryTitle: "Your unhelpful thought was…"
  },
  options: ["My sick parents will get the virus", "Things are getting worse and worse with the virus", "I have some symptoms so maybe I have the virus", "Other"],
  batteryId: "CORONA_ANXIETY_POSITIVES"
}, {
  prompt: "Do any of these reasons help you to feel a slight bit less worried?",
  type: "multi",
  options: ["A lot of people all around the world are working on containing it", "Most people travelling are aware of the virus and are taking precautions at an individual level", "Airports and airlines are aware and are taking precautions", "There are travel restrictions in place to prevent the spread"],
  batteryId: "CORONA_ANXIETY_POSITIVES",
  meta: {
    answerLabel: "Any of these make you less worried?",
    summaryTitle: "Do any of these reasons help you to feel a slight bit less worried?"
  }
}, {
  prompt: "Or any of these ones?",
  type: "multi",
  options: ["The growth has stopped and is declining in some countries", "A lot of people are working on a cure that might be ready soon", "I have access to good healthcare", "Statistically, the chances are very low"],
  batteryId: "CORONA_ANXIETY_POSITIVES",
  meta: {
    answerLabel: "Any of these make you less worried?",
    summaryTitle: "Do any of these reasons help you to feel a slight bit less worried?"
  }
}, {
  prompt: "How about these ones?",
  type: "multi",
  options: ["I’m under 75 and less at risk for the virus", "I’ve stressed out unnecessarily about potential disasters in the past but nothing bad happened"],
  batteryId: "CORONA_ANXIETY_POSITIVES",
  meta: {
    answerLabel: "Any of these make you less worried?",
    summaryTitle: "Do any of these reasons help you to feel a slight bit less worried?"
  }
}, {
  prompt: "If you did get sick would any of these things help you to cope?",
  type: "multi",
  options: ["Ask someone to look after me or check in with me", "Stay in contact with my doctor or a medical advice team", "Ask for help from friends or family"],
  batteryId: "CORONA_ANXIETY_POSITIVES",
  meta: {
    answerLabel: "Any of these help you cope?",
    summaryTitle: "Do you have adequate access to a good healthcare system?"
  }
}, {
  prompt: "Or these?",
  type: "multi",
  options: ["Ask for help from colleagues and my workplace", "Follow advice I’m given by my doctor or medical professionals", "Remind myself that most people recover within a few days"],
  batteryId: "CORONA_ANXIETY_POSITIVES",
  meta: {
    answerLabel: "Any of these help you cope?",
    summaryTitle: "If you did get sick would any of these things help you to cope?"
  }
}, {
  prompt: "Are there any other personal reasons that would help you to feel better about your ability to cope?",
  type: "textarea",
  meta: {
    answerLabel: "Personal reasons ability to cope",
    summaryTitle: "Are there any other personal reasons that would help you to feel better about your ability to cope?"
  },
  batteryId: "CORONA_ANXIETY_POSITIVES"
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;